// extracted by mini-css-extract-plugin
export default {"Details":"Details_Details__BZyyB","Left":"Details_Left__L10fE","Right":"Details_Right__TsTFG","Main":"Details_Main__+BNYd","About":"Details_About__XS2xy"};